import React, { createContext, useState, useContext } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [yearlySummaryData, setYearlySummaryData] = useState(null);

  return (
    <GlobalContext.Provider
      value={{
        yearlySummaryData,
        setYearlySummaryData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
